import React from "react"

import Section from "@components/section"
import Bottom from "./superSmashBros_bottom"

const En = () => {
  return (
    <>
      <Section title="Tournament Info">
        <table className="tableInfo">
          <tbody>
            <tr>
              <td>Schedule (Streaming)</td>
              <td>
                Jun 26th (Friday) 14:00 Team A top 6
                <br />
                Jun 27th (Saturday) 14:00 Team B top 6
                <br />
                Jul 4th (Saturday) 14:00 Team C top 6
                <br />
                Jul 5th (Sunday) 14:00 Team D top 6
                <br />
                Jul 12th (Sunday) 14: 00 Final Stage
                <br />
                （ Group Stage will start after registration ）
                <br />
                <br />
                <a href="https://www.huya.com/spark2020" target="_blank">
                  Streaming : huya 660161
                </a>
              </td>
            </tr>
            <tr>
              <td>Type</td>
              <td>Two Stages Online Tournament</td>
            </tr>
            <tr>
              <td>System</td>
              <td>Double Elimination</td>
            </tr>
            <tr>
              <td>Rules</td>
              <td>
                Best 2 out of 3 for Pools
                <br />
                Best 3 out of 5 for Finals
                <br />
                Stock: 3; Timer: 7:00; Items: Off
                <br />
                FS Meter: Off; Spirits: Off
                <br />
                Stage Selection: Loser's Pick
              </td>
            </tr>
            <tr>
              <td>Stages</td>
              <td>
                Starter：
                <br />
                Battlefield、Final Destination、Smashville、 Pokémon Stadium
                2、Town and City、
                <br />
                Counterpick:
                <br />
                Kalos Pokémon League、Lylat Cruise、 Yoshi's Story
              </td>
            </tr>
            <tr>
              <td>Game version</td>
              <td>Latest version</td>
            </tr>
            <tr>
              <td>Registration</td>
              <td>
                1.Fill out the registration form. 2.Scan the QR code to join the
                attendees Wechat group. 3.Follow the instructions in the Wechat
                group.
              </td>
            </tr>
            <tr>
              <td>Reward</td>
              <td>
                The top 3 players in each group will be qualified for the Online
                Final Tournament (about August) of Spark.
                <br />
                There will be an additional tournament for the winner of each
                group.
                <br />
                The winner of the additional tournament will be awarded 1500
                RMB.
              </td>
            </tr>
            <tr>
              <td>Online Final Tournament Reward</td>
              <td>
                1st : 3000 RMB
                <br />
                2nd : 1500 RMB
                <br />
                3rd : 1000 RMB
                <br />
              </td>
            </tr>
          </tbody>
        </table>
      </Section>
      <Section title="Notice of Contest">
        <div className="tips">
          <p>
            1.After the registration deadline, lots will be drawn by GAMECORES,
            the whole process will be issued to the chat group for confirmation.
          </p>
           
          <p>
            2.All team needs to have a proper connection to ensure smooth live
            streaming, and prepare for the contest in any moment. Please confirm
            your time before signing up.
          </p>
          <p>
            3.Any team is five minutes late or does not participate because of
            failure to arrive, leave early and other reasons, the team will be
            disqualified and the team's opponent will be awarded the victory.
          </p>
          <p>
            4.The ID, avatar, team name, clothing, carrying items, etc. of the
            player shall not contain any text, patterns or elements that include
            violation of the laws and regulations of the country or not suitable
            for appearance in the live broadcast of the contest. Any of the
            above prohibition, once verified, the team will be disqualified and
            stripped of their results;
          </p>
          <p>
            5.Players shall not make statements that violate national laws and
            regulations, insult or other statements that are not suitable for
            appearance in the live broadcast. In the event of the above
            prohibition, the team will be disqualified and stripped of their
            results.
          </p>
          <p>
            6.The GAMECORES CO. reserves all the right for final interpretation
            of the Contest.
          </p>
        </div>
      </Section>
      <Bottom isEn />
    </>
  )
}

export default En
